module.exports = "/_next/static/images/ae1269197ac3989d00b1a35e053e0504-row-1-transfer.svg";